import { ContactLeadRepository } from '../repositories/BaseRepository';
import { ContactLead } from '../data/types/analytics';

export const createContactLeadService = (contactLeadRepository: ContactLeadRepository) => ({
  async submitLead(lead: Omit<ContactLead, 'id' | 'created_at' | 'updated_at'>) {
    try {
      await contactLeadRepository.create(lead);
    } catch (error) {
      console.error('Error submitting lead:', error);
      throw error;
    }
  },
}); 